











































































// 3rd party libs
import {
    mapActions,
    mapGetters,
} from 'vuex';
import Vue from 'vue';

// Local Modules
import localStoreTypes from '@webapp/store/types.js';

// Shared Modules
import sharedEpicTypes from '@shared/epics/types.js';
import authStoreTypes from '@shared/store/modules/auth/types';
import {
    types as gaTypes,
} from '@shared/setups/analytics.js';

// Config
import socios from '@webapp/socios.json';
import {
    ServerConfigurationProps,
} from '@shared/types/config';

// Components
import loadingSpinner from '@webapp/components/loading-spinner/loading-spinner.vue';

// Utils
import {
    format,
} from '@shared/utils/dates.js';
import {
    AgreementTypeName,
} from '@shared/modules/customer-first/types/agreement';
import {
    getUserAgreementLink,
} from '@shared/utils/user-agreement';


export default Vue.extend({
    name: 'user-agreement',
    components: {
        loadingSpinner,
    },
    data() {
        return {
            loadingAcceptance: false,
            loadingSummary: true,
            iframeUrl: '',
            iframeHeight: 300,
        };
    },
    computed: {
        ...mapGetters([
            'userAgreementStatus',
            'localeISO2',
            'getLatestError',
            'getLatestValidationError',
            'userId',
            'isUsaRegulation',
            'device',
        ]),

        ...mapGetters('agreements', [
            'userAgreement',
            'isAgreementAccepted',
        ]),

        ...mapGetters('auth', ['getSessionAuthToken']),

        ...mapGetters('serverConfig', ['serverConfigByKey']),

        agreementApplyDate(): string {
            return this.userAgreement?.applyFrom
                ? format(new Date(this.userAgreement.applyFrom), 'dateDayMonthLong')
                : '--';
        },

        agreementGraceDate(): string {
            return this.userAgreement?.graceDate
                ? format(new Date(this.userAgreement.graceDate), 'dateMonthLong')
                : '--';
        },

        graceDateGreaterThanApplyDate() : boolean {
            return new Date(this.userAgreement.graceDate) > new Date(this.userAgreement.applyFrom);
        },

        userAgreementLink(): string {
            return getUserAgreementLink(this.userAgreement);
        },

        privacyPolicy(): string {
            return this.serverConfigByKey(ServerConfigurationProps.privacyPolicyLink);
        },

        agreementType(): AgreementTypeName {
            return this.isUsaRegulation ? AgreementTypeName.USA
                : AgreementTypeName.International;
        },

        analyticsParams() {
            return {
                gaType: gaTypes.LOG,
                parameters: [
                    {
                        key: 'userId',
                        value: this.userId,
                    },
                ],
            };
        },
    },
    watch: {
        getLatestError(error) {
            const fetchErrors = this.utilGlobalHandleErrorMessages(error);

            this.$notify({
                type: 'error',
                text: fetchErrors.message,
            });
            this.loadingAcceptance = false;
        },

        getLatestValidationError(error) {
            const fetchErrors = this.utilGlobalHandleErrorMessages(error);

            this.$notify({
                type: 'error',
                text: fetchErrors.message,
            });
            this.loadingAcceptance = false;
        },
    },
    async mounted() {
        await this.fetchUserAgreement({
            details: ['agreementVersionTranslations'],
            locales: [this.localeISO2],
        });
        await this.setIframeUrl();

        window.addEventListener('message', this.setIframeHeight);
    },
    destroyed() {
        window.removeEventListener('message', this.setIframeHeight);
    },
    methods: {
        ...mapActions({
            doAppDataRefresh: sharedEpicTypes.REFRESH_APP_DATA,
            resetModal: localStoreTypes.RESET_MODAL,
            setIsWebviewOpen: 'setIsWebviewOpen',
        }),

        ...mapActions('agreements', [
            'fetchUserAgreement',
            'acceptUserAgreement',
            'setUserAgreementAlreadyShown',
            'fetchUserAgreementSummary',
        ]),

        ...mapActions('auth', {
            fetchSessionAuthToken: authStoreTypes.GET_SESSION_AUTH_TOKEN,
        }),

        async acceptAgreement() {
            this.loadingAcceptance = true;
            await this.acceptUserAgreement(this.userAgreement.id);

            if (this.isAgreementAccepted(this.userAgreement.id)) {
                await this.doAppDataRefresh();
                this.closeModal();
            }
            this.loadingAcceptance = false;
        },

        closeModal() {
            this.setUserAgreementAlreadyShown(true);
            this.resetModal();
        },

        onSummaryLoad() {
            this.loadingSummary = false;
        },

        async setIframeUrl() {
            await this.fetchSessionAuthToken();

            const queryParams = `generatedCode=${this.getSessionAuthToken}
                &userId=${this.userId}
                &deviceUid=${this.device.uuid}
                &deviceName=${this.device.name}
                &locale=${this.localeISO2}
                &agreementType=${this.agreementType}
                &type=terms
            `.replace(/\s/g, '');

            const url = `${socios.paymentGatewayUrl}/terms-and-conditions?${queryParams}`;

            this.iframeUrl = encodeURI(url);
        },

        setIframeHeight({ data }) {
            if (data.type === 'summaryHeight') {
                this.iframeHeight = data.height;
            }
        },
    },
});
